var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _vm._m(0),
    _c("div", { staticClass: "panel-body" }, [
      _c("div", { staticClass: "table-responsive" }, [
        _c(
          "table",
          { staticClass: "table table-bordered table-happy nomargin" },
          [
            _vm._m(1),
            _c(
              "tbody",
              [
                _vm._l(_vm.order.products, function(prod, index) {
                  return [
                    _c("tr", { key: prod.id }, [
                      _c("td", [_vm._v(_vm._s(index + 1))]),
                      _c("td", [
                        _c("div", { staticClass: "name-box" }, [
                          _c("div", { staticClass: "img" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: prod.linkOrigin,
                                  target: "_blank"
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: decodeURIComponent(prod.imageOrigin)
                                  }
                                })
                              ]
                            )
                          ]),
                          _c("div", { staticClass: "name" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: prod.linkOrigin,
                                  target: "_blank"
                                }
                              },
                              [_vm._v(_vm._s(prod.titleOrigin))]
                            )
                          ])
                        ])
                      ]),
                      _c("td", [
                        _c("div", { staticClass: "name-box" }, [
                          _c("div", { staticClass: "name-proper" }, [
                            _c("span", [_vm._v(_vm._s(prod.property))])
                          ])
                        ])
                      ]),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(prod.quantity) +
                            "\n                            "
                        )
                      ]),
                      _c("td", { staticClass: "text-right" }, [
                        _c("div", { staticClass: "price" }, [
                          _c("div", [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(
                                  _vm._f("formatNumber")(
                                    prod.pricePromotionVND ||
                                      prod.priceOriginVND,
                                    "0,0"
                                  )
                                ) +
                                " VND\n                                        "
                            )
                          ]),
                          _c("div", [
                            _c("i", [
                              _vm._v(
                                "¥" +
                                  _vm._s(
                                    _vm._f("formatNumber")(
                                      prod.pricePromotion || prod.priceOrigin,
                                      "0,0.[000]"
                                    )
                                  )
                              )
                            ])
                          ])
                        ])
                      ]),
                      _c("td", { staticClass: "text-right" }, [
                        _c("div", { staticClass: "price" }, [
                          _c("div", { staticClass: "text-primary" }, [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(
                                  _vm._f("formatNumber")(prod.amount, "0,0")
                                ) +
                                " VND\n                                        "
                            )
                          ]),
                          _c("div", { staticClass: "text-danger" }, [
                            _c("i", [
                              _vm._v(
                                "¥" +
                                  _vm._s(
                                    _vm._f("formatNumber")(
                                      prod.amountCN,
                                      "0,0.[000]"
                                    )
                                  )
                              )
                            ])
                          ])
                        ])
                      ])
                    ]),
                    prod.comment && prod.comment !== ""
                      ? _c("tr", { key: prod.id }, [
                          _c("td", { attrs: { colspan: "7" } }, [
                            _c("div", { staticClass: "comment" }, [
                              _c("b", [_vm._v("Ghi chú:")]),
                              _vm._v(
                                " " +
                                  _vm._s(prod.comment) +
                                  "\n                                "
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  ]
                }),
                _c("tr", [
                  _vm._m(2),
                  _c("td", { staticClass: "text-right fb" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatNumber")(_vm.productsQuantity, "0,0")
                      )
                    )
                  ]),
                  _c("td"),
                  _c("td", { staticClass: "text-right fb" }, [
                    _c("div", { staticClass: "price" }, [
                      _c("div", { staticClass: "text-primary" }, [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(
                              _vm._f("formatNumber")(_vm.order.amountVND, "0,0")
                            ) +
                            " VND\n                                "
                        )
                      ]),
                      _c("div", { staticClass: "text-danger" }, [
                        _c("i", [
                          _vm._v(
                            "¥" +
                              _vm._s(
                                _vm._f("formatNumber")(
                                  _vm.order.amountCNY,
                                  "0,0.[000]"
                                )
                              )
                          )
                        ])
                      ])
                    ])
                  ])
                ]),
                _c("tr", [
                  _vm._m(3),
                  _c("td"),
                  _c("td", { staticClass: "text-right fb" }, [
                    _c("div", { staticClass: "price" }, [
                      _c("div", { staticClass: "text-primary" }, [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(
                              _vm._f("formatNumber")(
                                _vm.order.feeShipCNVND,
                                "0,0"
                              )
                            ) +
                            " VND\n                                "
                        )
                      ]),
                      _c("div", { staticClass: "text-danger" }, [
                        _c("i", [
                          _vm._v(
                            "¥" +
                              _vm._s(
                                _vm._f("formatNumber")(
                                  _vm.order.feeShipCN,
                                  "0,0.[000]"
                                )
                              )
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              ],
              2
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [_vm._v("Danh sách sản phẩm")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "w45" }),
        _c("th", { staticClass: "w200" }, [_vm._v("Sản phẩm")]),
        _c("th", [_vm._v("Thuộc tính")]),
        _c("th", { staticClass: "text-right w120" }, [_vm._v("Số lượng")]),
        _c("th", { staticClass: "text-right w180" }, [_vm._v("Đơn giá")]),
        _c("th", { staticClass: "text-right w180" }, [_vm._v("Thành tiền")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("span", { staticClass: "fb" }, [_vm._v("Tổng")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("span", { staticClass: "fb" }, [_vm._v("Phí ship nội địa TQ")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }